import React, { useEffect, useState } from "react";
import menuIcon from "../../assets/images/menuIcon.svg";
import notificationIcon from "../../assets/images/notification.svg";
import "./header.scss";
import MenuDrawer from "../landingPage/menu/MenuDrawer";
import TimeLineDrawer from "../landingPage/timeline/TimeLineDrawer";
import {
  getLoggedUserInfo,
  getTimeline,
  unreadTimelineCount,
} from "../../services/websiteApi";
import { getParams } from "../../utlis/helpers";
import { Skeleton, Typography } from "@mui/material";
import { setAPILoader } from "../../state/actions/globalAction";
import { useDispatch } from "react-redux";
import { useSection } from "../../i18n/useSection";
import { PERSON_DASHBOARD } from "../../routes/routerPath";
import { isWebView } from "../../utlis/webViewBridge";

function Header() {
  const [openMenuDrawer, setOpenMenuDrawer] = useState(false);
  const [openTimelineDrawer, setTimelineDrawer] = useState(false);
  const [user, setUser] = useState([]);
  const [timelineCount, setTimelineCount] = useState();
  const dispatch = useDispatch();
  const [timeline, setTimeline] = useState([]);
  const toggleDrawer = () => {
    setOpenMenuDrawer(false);
  };
  const { staffId } = getParams();
  const { welcome } = useSection("landing");
  const path = window.location.pathname;

  if (isWebView()) return null;
  useEffect(() => {
    const storedTest = JSON.parse(sessionStorage.getItem("staffDetails"));
    dispatch(setAPILoader(true));
    if (storedTest) {
      setUser(storedTest);
      dispatch(setAPILoader(false));
    } else {
      getLoggedUserInfo(staffId)
        .then((res) => {
          setUser(res?.data?.data);
          sessionStorage.setItem(
            "staffDetails",
            JSON.stringify(res?.data?.data),
            dispatch(setAPILoader(false)),
          );
        })
        .catch(() => {
          dispatch(setAPILoader(false));
        });
    }
    if (path === "/" || path === PERSON_DASHBOARD) {
      unreadTimelineCount()
        .then((res) => {
          setTimelineCount(res?.data?.count);
          dispatch(setAPILoader(false));
        })
        .catch(() => {
          dispatch(setAPILoader(false));
        });
    }
  }, [path]);

  const timelineDataShow = () => {
    dispatch(setAPILoader(true));
    setTimelineDrawer(true);
    getTimeline()
      .then((res) => {
        setTimeline(res?.data?.data);
        dispatch(setAPILoader(false));
      })
      .catch(() => {
        dispatch(setAPILoader(false));
      });
  };
  const timelineCloseHandler = () => {
    setTimelineDrawer(false);
    setTimelineCount(0);
  };
  return (
    <>
      <div className="header-wrapper">
        <div className="item first">
          <img
            src={menuIcon}
            alt="menu"
            onClick={() => setOpenMenuDrawer(true)}
            className="header-icon"
          />
        </div>
        <div className="item  middle">
          {user?.picture ? (
            <img src={user?.picture} alt="profile" className="profile-img" />
          ) : (
            <Skeleton variant="circular" className="profile-img" />
          )}

          <Typography>
            {welcome} {user?.name}
          </Typography>
        </div>
        <div className="item last">
          <img
            src={notificationIcon}
            alt="notify"
            onClick={() => timelineDataShow()}
            className="header-icon"
          />

          {timelineCount > 0 && (
            <div className="timeline-count">{timelineCount}</div>
          )}
        </div>
      </div>

      <MenuDrawer
        openMenuDrawer={openMenuDrawer}
        setOpenMenuDrawer={toggleDrawer}
        user={user}
      />
      <TimeLineDrawer
        openTimelineDrawer={openTimelineDrawer}
        timelineCloseHandler={timelineCloseHandler}
        timeline={timeline}
      />
    </>
  );
}

export default Header;
